module.exports = __webpack_public_path__ + "static/media/Onboarding-MefacaPerguntas2x.c47dba92.png";